"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditEventLabel = void 0;
var EditEventLabel;
(function (EditEventLabel) {
    EditEventLabel["PASSWORD"] = "Password";
    EditEventLabel["DELETE_ACCOUNT"] = "Delete account";
})(EditEventLabel || (exports.EditEventLabel = EditEventLabel = {}));
//# sourceMappingURL=EditEventLabel.js.map